import { useState, useEffect } from 'react';
import { Modal, Box, TextField, Typography, Button } from '@mui/material';
import { useToast } from '@/context_providers/toast_context/ToastContext';
import COLORS from '../../../../resources/style/Themes';
import { OrgNoteOnAzure } from '../../../../../generated-client/models';

interface EditNotModalProps {
  show: boolean;
  onHide: () => void;
  note: OrgNoteOnAzure | undefined;
  onSave: (editedNote: OrgNoteOnAzure) => void;
}

export default function EditNoteModal({
  show,
  onHide,
  note,
  onSave,
}: EditNotModalProps) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [id, setId] = useState('');
  const [orgCode, setOrgCode] = useState('');

  const { showErrorToast } = useToast();

  useEffect(() => {
    if (note) {
      setTitle(note.note_name);
      setContent(note.note);
      setOrgCode(note.org_code);
      setId(note.id);
    }
  }, [note]);

  const handleSave = () => {
    const updatedNote: OrgNoteOnAzure = {
      org_code: orgCode,
      note: content,
      note_name: title,
      id: id,
      _etag: note?._etag ?? '',
      _ts: Date.now(),
      object_type: note?.object_type ?? '',
      unique_key: note?.unique_key ?? '',
    };
    onSave(updatedNote);
    setTitle('');
    setContent('');
    setId('');
    setOrgCode('');
    onHide();
  };

  return (
    <Modal
      open={show}
      onClose={onHide}
      aria-labelledby="edit-note-modal-title"
      aria-describedby="edit-note-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          outline: 'none',
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            backgroundColor: COLORS.SAFEGUARD_BLUE,
            color: COLORS.WHITE,
            padding: 2,
            borderTopLeftRadius: 2,
            borderTopRightRadius: 2,
          }}
        >
          <Typography
            id="edit-note-modal-title"
            variant="h6"
            sx={{
              textAlign: 'center',
            }}
          >
            Edit {title}
          </Typography>
        </Box>
        {/* Modal Content */}
        <Box component="form" sx={{ p: 4 }}>
          <TextField
            fullWidth
            label="Title"
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Message"
            variant="outlined"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            sx={{ mb: 2 }}
          />
        </Box>
        {/* Footer Section */}
        <Box sx={{ textAlign: 'right', p: 2 }}>
          <Button
            variant="contained"
            onClick={handleSave}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
